import { useEffect, useState } from "react";


const SearchComp = (props) => {


  const [txtToSearch, setTxtToSearch] = useState();


  useEffect(() => {
  }, [])


  const checkIfEnter = (e) => {
    if (e.key === 'Enter') {

      searchMe()
    }

  }

  const searchMe = () => {
    props.srchFunc(txtToSearch)
  }



  return (
    <div className={"SearchDiv"}>
      <input type="text" valu={txtToSearch}
        onKeyUp={(e) => checkIfEnter(e)}
        onChange={(e) => setTxtToSearch(e.target.value)}
        placeholder={props.pHolder} />
      <img id="searchBtn" src="/PermanentImages/searchIc.gif" alt="" onClick={() => searchMe()} />
    </div>
  )

}

export default SearchComp;
